/* eslint-disable */
(function() {
  // Save the original __webpack_require__.e function
  var originalEnsure = __webpack_require__.e;

  // Create a retry wrapper around the original ensure function
  function retryEnsure(chunkId, retries = 5) {

    function tryEnsure(attempt) {
      return originalEnsure(chunkId).catch(error => {
        if (attempt < retries) {
          return tryEnsure(attempt + 1);
        } else {
          throw error;
        }
      });
    }
    return tryEnsure(1);
  }

  // Patch the original __webpack_require__.e function
  __webpack_require__.e = function(chunkId) {
    return retryEnsure(chunkId);
  };

  // If there are any additional properties or methods on __webpack_require__.e, copy them over
  for (var key in originalEnsure) {
    if (originalEnsure.hasOwnProperty(key)) {
      __webpack_require__.e[key] = originalEnsure[key];
    }
  }
})();
